module.exports = __webpack_public_path__ + "static/ic-menu-immunity-passport-disabled-bf28f92e9db1a1cf3958d6dfbf4ae409.svg";